import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-002bd23b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-12" }
const _hoisted_2 = { class: "row justify-content-center" }
const _hoisted_3 = { class: "col-lg-7 bg-gray mb-3 mb-lg-5 p-4 position-relative" }
const _hoisted_4 = { class: "text-center fw-bold fs-6" }
const _hoisted_5 = { class: "text-center fs-7 mb-4" }
const _hoisted_6 = { class: "row mb-4 mb-lg-2" }
const _hoisted_7 = { class: "col-lg-4 text-center text-lg-start fs-7" }
const _hoisted_8 = { class: "col-lg-8 text-center text-lg-start fs-7 text-break" }
const _hoisted_9 = { class: "row mb-4 mb-lg-2" }
const _hoisted_10 = { class: "col-lg-4 text-center text-lg-start fs-7" }
const _hoisted_11 = { class: "col-lg-8 text-center text-lg-start fs-7" }
const _hoisted_12 = { class: "row mb-4 mb-lg-2" }
const _hoisted_13 = { class: "col-lg-4 text-center text-lg-start fs-7" }
const _hoisted_14 = { class: "col-lg-8 text-center text-lg-start fs-7" }
const _hoisted_15 = { class: "d-lg-flex pb-2" }
const _hoisted_16 = { class: "col-lg-4 text-center text-lg-start fs-7" }
const _hoisted_17 = { class: "col-lg-8 text-center text-lg-start fs-7 text-break" }
const _hoisted_18 = { class: "d-lg-flex pb-2" }
const _hoisted_19 = { class: "col-lg-4 text-center text-lg-start fs-7" }
const _hoisted_20 = { class: "col-lg-8 text-center text-lg-start fs-7 text-break" }
const _hoisted_21 = { class: "d-lg-flex pb-2" }
const _hoisted_22 = { class: "col-lg-4 text-center text-lg-start fs-7" }
const _hoisted_23 = { class: "col-lg-8 text-center text-lg-start fs-7" }
const _hoisted_24 = { class: "row d-lg-flex justify-content-center align-items-center" }
const _hoisted_25 = { class: "col-lg-6 d-flex justify-content-center" }

import { computed, ref, watchEffect, ComputedRef } from 'vue'
import { useStore } from 'vuex'
import dayjs from 'dayjs'

import Button from '@/components/button/index.vue'
import { translate } from '@/languages/i18n'
import { ID } from '../languages/ID'
import { COMMUNITY_STORE } from '@/store/constants'
import PortfolioModal from '@/views/user/account/profile/setting/components/PortfolioModal.vue'
import { CommunityStateTypes } from '@/store/modules/community'
import { getWorkingPeriod } from '@/constants/datepicker'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()

const me = computed<ComputedRef<Pick<CommunityStateTypes, 'me'>>>(() => store.getters[COMMUNITY_STORE.GETTERS.GET_ME])

const data = ref({
  family_name: '',
  given_name: '',
  family_name_kana: '',
  given_name_kana: '',
  birthday: '',
  email: '',
  institution: '',
  job: '',
  enrollment_start_period: '',
})

watchEffect(() => {
  data.value = {
    family_name: me.value?.profile?.family_name,
    given_name: me.value?.profile?.given_name,
    family_name_kana: me.value?.profile?.family_name_kana,
    given_name_kana: me.value?.profile?.given_name_kana,
    birthday: me.value?.profile?.birthday,
    email: me.value?.profile?.email,
    institution: me.value?.profile?.institution,
    job: me.value?.profile?.job_type_parent + ' ' + me.value?.profile?.job_type_child,
    enrollment_start_period: me.value?.profile?.enrollment_start_period,
  }
})

const transitToEdit = () => {
  window.open('/alumni/account/profile/edit', '_blank')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h3", _hoisted_4, _toDisplayString(data.value.family_name) + " " + _toDisplayString(data.value.given_name), 1),
          _createElementVNode("h4", _hoisted_5, _toDisplayString(data.value.family_name_kana) + " " + _toDisplayString(data.value.given_name_kana), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(translate)('email')), 1),
            _createElementVNode("div", _hoisted_8, _toDisplayString(data.value.email), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(translate)('dateOfBirth')), 1),
            _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(dayjs)(data.value.birthday).format('YYYY年M月D日')), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(translate)(`${_unref(ID)}currentJob`)), 1),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(translate)('affiliation')), 1),
                _createElementVNode("div", _hoisted_17, _toDisplayString(data.value.institution), 1)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(translate)('occupation')), 1),
                _createElementVNode("div", _hoisted_20, _toDisplayString(data.value.job), 1)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(translate)('affiliationPeriod')), 1),
                _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(dayjs)(data.value.enrollment_start_period).format('YYYY/M')) + " " + _toDisplayString(_unref(translate)('SA20from')) + " 現在 " + _toDisplayString(_unref(getWorkingPeriod)(data.value.enrollment_start_period)), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createVNode(Button, {
                title: _unref(translate)('accountSetting'),
                type: 'secondary',
                size: 'small',
                onClick: transitToEdit
              }, null, 8, ["title"])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(PortfolioModal, {
      workTime: `${_unref(dayjs)(data.value.enrollment_start_period).format('YYYY/M') + _unref(translate)('SA20from')} 現在 ${_unref(getWorkingPeriod)(data.value.enrollment_start_period)}`
    }, null, 8, ["workTime"])
  ], 64))
}
}

})